import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import axios from "axios";
import SelectListComponent from "../SelectListComponent";
import { globalConfig } from "../../../config/config";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
// const querystring = require("querystring");

const CreateContentFacadeType = () => {
  const [contentFacadeTypeCodes, setContentFacadeTypeCodes] = useState([]);
	const token = globalConfig.hardcoded_header;
  const [message, setMessage] = useState("");
  const [state, setState] = useState({
    contentFacadeTypeId: 0,
    contentFacadeTypeValueCode: 0,
    contentFacadeTypeDescr: "",
    contentFacadeTypeCdata: "",
    contentFacadeTypeBdata: "",
    securityContextId: 0,
    createUser: 0,
    createDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  // function handleDropDown(event) {
  //   console.log(event);
  //   var target = event.target;
  //   console.log(target.id + ":" + target.value);
  //   this.setState({
  //     [target.id]: parseInt(target.value),
  //   });

  //   console.log(this.state);
  // }

  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-facade-types`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-facade-types/contentFacadeTypeId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentFacadeTypeId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentFacadeTypeId
          );
          if (
            response2.status === 200 &&
            response2.data.contentFacadeTypeId === state.contentFacadeTypeId
          ) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      //     console.log(response.data)
      //          .catch(err => {
      //             console.log(err);
      //           });
      console.log("message info - " + message);
      setState({
        ...state,
        contentFacadeTypeId: 0,
        contentId: 0,
        contentCategoryTypeId: 0,
        contentCategoryName: " ",
        contentCategoryDescr: " ",
        lastUpdateUser: 0,
        lastUpdateDate: new Date().toISOString(),
      });
    });

    // console.log("SetState Message info-" + this.contentObjectName);
    // console.log("SetState Message info-" + this.contentCategoryName);
    // console.log("SetState Message info-" + this.contentCategoryDescr);
  }
  function handleRest(event) {
    setState({
      ...state,
      contentId: 0,
      contentCategoryTypeId: 0,
      contentCategoryName: " ",
      contentCategoryDescr: " ",
    });
    this.contentObjectName = "";
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_FACADE_TYPE`,
         apiHeader(token)
      )
      .then((res) => {
        const contentIndexTypeCodes = res.data;
        console.log("results", contentIndexTypeCodes);
        setContentFacadeTypeCodes(contentIndexTypeCodes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });
  };

  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Facade Type</h4>			
			<Link to="/breeze/list-content-facade-types">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Facade Type Value Code"
          >
            Content Facade Type Value Code
          </label>
          <select
            id="contentFacadeTypeValueCode"
            onChange={handleChange}
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeTypeValueCode}
          >
            <option value={0}>Select Facade Type Value Code </option>
            {contentFacadeTypeCodes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
            {/* <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('CONTENT_FACADE_TYPE')}"/> */}
          </select>
          {/* <SelectListComponent
            entityName={"system-code-values"}
            valueFilterColumnName={"systemCodeId"}
            valueFilter={"235"}
            displayColumnName={"systemCodeValueValue"}
            keyColumnName={"systemCodeValueId"}
            IdName={"contentFacadeTypeValueCode"}
            TypeId={state.contentFacadeTypeValueCode}
            handle={handleDropDown}
          /> */}
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Facade Type Description"
          >
            Content Facade Type Description
          </label>
          <textarea
            id="contentFacadeTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeTypeDescr}
            onChange={handleChange}
          />
        </div>
        {/* <div className="form-group row">
				<label className="ContentTitle col-sm-2" value="Content Facade Type CData">Content Facade Type CData</label>
				<input id="contentFacadeTypeCdata" className="form-control input-xlarge col-sm-8" value="#{ombContentFacadeTypeForm.createContentFacadeType.contentFacadeTypeCdata}"/>
		    </div> */}
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handleRest}>
          {" "}
          Clear
        </button>
        &nbsp;
        <button className="btn btn-success" value="Create" onClick={handleSubmit}>
          {" "}
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentFacadeType;

